import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import {
	CALCULATE_QUOTE_RENEWAL_API_URL,
	CONFIRM_QUOTE_RENEWAL_API_URL,
	LOAD_QUOTE_FOR_RENEWAL_API_URL,
} from "../../configs/api-paths";
import BaseInsuranceCalculatorService from "../base/BaseInsuranceCalculatorService";

/**
 * Service dealing with insurance renewals.
 */
class InsuranceRenewalService extends BaseInsuranceCalculatorService {
	@observable
	insuranceForRenewal = null;

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setInsuranceForRenewal = (data) => {
		this.insuranceForRenewal = data;
	};

	loadInsuranceForRenewal = async (policyNumber) => {
		let hideLoadingMessage = message.loading("Loading...", 0);

		try {
			const quote = await super.loadRequest(
				`${LOAD_QUOTE_FOR_RENEWAL_API_URL}?policyNumber=${policyNumber}`
			);
			this.setInsuranceForRenewal(quote);

			hideLoadingMessage();
		} catch (error) {
			console.log(error);

			hideLoadingMessage();
			message.error(
				`There was error while trying to load quote data from the server. Error: ${error}`
			);
		}
	};

	loadInsuranceForRenewalFromRenewalsPage = async (quoteId) => {
		let hideLoadingMessage = message.loading("Loading...", 0);

		try {
			const quote = await super.loadRequest(
				`${LOAD_QUOTE_FOR_RENEWAL_API_URL}QuoteId?quoteId=${quoteId}`
			);
			this.setInsuranceForRenewal(quote);

			hideLoadingMessage();
		} catch (error) {
			console.log(error);

			hideLoadingMessage();
			message.error(
				`There was error while trying to load quote data from the server. Error: ${error}`
			);
		}
	};


	calculateInsuranceRenewal = async () => {
		const insuranceForRenewal = this.insuranceForRenewal;
		this.setInsuranceForRenewal(null);

		let hideLoadingMessage = message.loading("Loading...", 0);

		try {
			const propsToSend = [
				"organisation",
				"organisation_name",
				"organisation_type",
				"startDate",
				"pl_turnover",
				"el",
				"el_wageroll",
				"el_volunteer_staff",
				"equipment",
				"equipment_cover_amt",
				"uk_only",
				"ngb_qualified",
				"appropriate_training",
				"hazardous_materials",
				"risk_assessment",
				"participation_form",
				"safety_briefing",
				"correct_operation",
				"previous_claims",
				"insurance_declaration",
				"activityTrades",
			];

			const result = await super.calculateRequest(
				CALCULATE_QUOTE_RENEWAL_API_URL,
				propsToSend,
				insuranceForRenewal
			);

			hideLoadingMessage();
			this.setInsuranceForRenewal(result);
		} catch (error) {
			console.log(error);
			this.setInsuranceForRenewal(insuranceForRenewal);

			hideLoadingMessage();
			message.error(
				`There was error while trying to send data to the server. Error: ${error}`
			);
		}
	};

	confirmInsuranceRenewal = async () => {
		try {
			const quoteId_fix = this.insuranceForRenewal.amendedQuoteData.quoteId;
			const insuranceForRenewal = this.insuranceForRenewal;

			// Assuming propsToSend should include keys from insuranceForRenewal to be sent.
			const propsToSend = [
				// List of property names to be sent in the request
				// Adjust this list based on the actual properties you want to send
				"organisation", "organisation_name", "organisation_type", "startDate", "pl_turnover",
				"el", "el_wageroll", "el_volunteer_staff", "equipment", "equipment_cover_amt",
				"uk_only", "ngb_qualified", "appropriate_training", "hazardous_materials",
				"risk_assessment", "participation_form", "safety_briefing", "correct_operation",
				"previous_claims", "insurance_declaration", "activityTrades"
			];

			// Preparing bodyPrepend with the fixed quote ID
			const bodyPrepend = { quoteId: quoteId_fix };

			// No bodyAppend in this case, but you can adjust as needed
			const bodyAppend = {};

			const response = await this.confirmRequest(
				CONFIRM_QUOTE_RENEWAL_API_URL,
				propsToSend,
				insuranceForRenewal,
				bodyPrepend,
				bodyAppend,
				quoteId_fix // Seems like an extra parameter not used in the function definition
			);

			// Check response and proceed accordingly
			if (!response.ok) {
				const errorData = await response.json();
				message.error(`Failed to confirm renewal: ${errorData.message}`);
				return;
			}

			const result = await response.json();
			this.context.thankYouService.setThankYouData(result);
			message.success('Successfully confirmed renewal. We will send a copy to the email provided.');
		} catch (error) {
			console.error('Error confirming insurance renewal:', error);

		}
	};




}

export default InsuranceRenewalService;
